import { Users, Award, Pencil, CircleX, Trash2 } from "lucide-react";
import logoImg from "../assets/logoiii.png";
import { useState } from "react";

import EditPlan from "./EditPlan";
import { useDispatch, useSelector } from "react-redux";
import { deletePlan } from "../redux/slices/plansSlice";

const PlansCards = ({ plan }) => {
  if (!plan) return null;

  const [value, setValue] = useState(false);
  const [editPlan, setEditPlan] = useState(false);
  const dispatch = useDispatch();

  const handleActive = () => {
    setValue(true);
  };
  const handleInactive = () => {
    setValue(false);
  };

  const handleSubmit = async () => {
    const confirmed = window.confirm("¿Deseas eliminar el plan?");
    if (!confirmed) return;

    try {
      const res = await dispatch(deletePlan(plan.id));
      console.log(res);
      return res;
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
    {plan ? (
    <div
      className="w-full max-w-4xl lg:max-w-6xl mx-auto px-2 relative pt-4"
      onMouseEnter={handleActive}
      onMouseLeave={handleInactive}
    >
      <div
        className="w-full flex flex-col md:flex-row overflow-hidden rounded-3xl text-white transform transition-transform duration-200 hover:scale-100 relative"
        style={{
          backgroundImage: "url('/images/background1.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Sección izquierda */}
        <div className="p-6 sm:p-8 lg:p-10 flex-1 flex flex-col justify-center z-10">
          <div className="flex items-center gap-3 mb-4 sm:mb-6">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl text-yellow-400 font-bold">
              {plan.name}
            </h2>
            <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16">
              <img
                src={logoImg}
                alt="Plan logo"
                className="opacity-80 w-full h-full object-contain"
              />
            </div>
          </div>

          <div className="space-y-3 sm:space-y-4">
            <div className="flex gap-3">
              <Users className="w-5 h-5 mt-1 flex-shrink-0 text-gray-300" />
              <p className="text-sm sm:text-base lg:text-lg text-gray-200">
                {plan.detail}
              </p>
            </div>

            <div className="flex gap-3">
              <Award className="w-5 h-5 mt-1 flex-shrink-0 text-gray-300" />
              <p className="text-sm sm:text-base lg:text-lg text-gray-200">
                Perfil de miembro con insignia {plan.badgeTier}
              </p>
            </div>
          </div>
        </div>

        {/* Troquel solo visible en md+ */}
        <div className="hidden md:flex flex-col justify-between items-center px-4 relative z-0">
          <div className="absolute -top-1 left-1/2 w-4 h-4 bg-black rounded-full -translate-x-1/2 z-20" />
          <div className="flex flex-col justify-center items-center h-full">
            {Array.from({ length: 30 }).map((_, i) => (
              <div
                key={i}
                className="w-2 h-2 rounded-full bg-black opacity-80 my-[2px]"
              />
            ))}
          </div>
          <div className="absolute -bottom-1 left-1/2 w-4 h-4 bg-black rounded-full -translate-x-1/2 z-20" />
        </div>

        {/* Sección derecha */}
        <div className="p-6 sm:p-8 lg:p-10 w-full md:w-64 lg:w-80 flex flex-col justify-center items-center z-10 bg-black/60 md:bg-transparent relative">
          {value && (
            <div className="absolute top-4 right-4 z-20 flex gap-2">
              <button onClick={() => setEditPlan(true)}>
                <Pencil className="text-white" />
              </button>
              <button onClick={handleSubmit}>
                <Trash2 className="text-white" />
              </button>
            </div>
          )}

          <div className="text-center">
            <p className="text-base text-gray-300 mb-1">Precio:</p>
            <div className="mb-5">
              <span className="text-xl sm:text-2xl font-medium">ARS</span>
              <span className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold">
                {" "}
                ${plan.price.toLocaleString()}
              </span>
            </div>
            <button className="bg-yellow-400 hover:bg-yellow-500 text-black font-medium px-6 py-2 lg:px-8 lg:py-3 rounded-full text-sm sm:text-base">
              Activar Membresía
            </button>
          </div>
        </div>
      </div>

      {/* Modal EditPlan */}
      {editPlan && (
        <div className="fixed inset-0 bg-black bg-opacity-80 z-50 overflow-y-auto">
          <div className="min-h-screen flex justify-center items-start py-12 px-4">
            <div className="relative rounded-2xl p-6 max-w-lg w-full shadow-xl">
              {/* Botón de cierre */}
              <button
                className="absolute top-4 right-4 text-black text-2xl transition-colors"
                onClick={() => setEditPlan(false)}
                aria-label="Cerrar"
              >
                <CircleX className="text-white hover:text-red-500"/>
              </button>

              <EditPlan plan={plan} />
            </div>
          </div>
        </div>
      )}
    </div>
    ) : (
      <h2>No hay Planes disponibles</h2>
    )}
    
    </>
  );
};

export default PlansCards;
